import { SEND_SMS_APP_LINK, SEND_SMS_APP_LINK_DONE, SEND_SMS_APP_LINK_ERROR, RESET_SEND_SMS_APP_LINK } from './actionTypes';
export const sendSmsAppLink = (data) => ({
    type: SEND_SMS_APP_LINK,
    data
});
export const sendSmsAppLinkDone = (data) => ({
    type: SEND_SMS_APP_LINK_DONE,
    data
});
export const sendSmsAppLinkError = (errorMessage) => ({
    type: SEND_SMS_APP_LINK_ERROR,
    errorMessage
});
export const resetSendSmsAppLink = () => ({
    type: RESET_SEND_SMS_APP_LINK
});
//# sourceMappingURL=actionCreators.js.map